<template>
  <div v-if="productImageUrls.length > 0" class="row">
    <div
      v-for="(pictureObject, index) in productImageUrls"
      :key="index"
      :class="{ 'mt-4': index > 0, 'col-4': index > 0 }"
    >
      <div
        @click="moveToFirstIndex(productImageUrls, index)"
        @keyup.enter="moveToFirstIndex(productImageUrls, index)"
        :class="{
          card: true,
          'product-card': true,
          'product-card-no-animation': index == 0,
        }"
        style="cursor: pointer"
        tabindex="0"
      >
        <div v-if="pictureObject.url" class="card-img-container">
          <img :src="pictureObject.url" alt="Produktbillede" class="card-img" />
        </div>
        <div v-else class="card-img-container">
          <img
            :src="require('/src/assets/graphics/chemistry-icon.svg')"
            alt="Placeholder, produktbillede"
            class="card-img"
          />
        </div>
        <p
          v-if="pictureObject.source && index == 0"
          style="margin: 0; color: var(--darkgrey)"
        >
          {{ "Kilde: " + pictureObject.source }}
        </p>
        <div
          v-if="index == 0 && productCard.reaction.name_d"
          class="card-img-overlay"
        >
          <div
            :class="{
              'product-reaction': true,
              'product-reaction-light': productCard.reaction.name_d
                ? productCard.reaction.name_d
                    .toLowerCase()
                    .includes('indskærpelse')
                : false,
              'product-reaction-medium': productCard.reaction.name_d
                ? productCard.reaction.name_d.toLowerCase().includes('forbud')
                : false,
              'product-reaction-dark': productCard.reaction.name_d
                ? productCard.reaction.name_d.toLowerCase().includes('påbud')
                : false,
            }"
          >
            {{ productCard.reaction.name_d }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="card product-card product-card-no-animation">
      <div class="card-img-container">
        <img
          :src="require('/src/assets/graphics/chemistry-icon.svg')"
          alt="Placeholder, produktbillede"
          class="card-img"
        />
      </div>

      <div class="card-img-overlay" v-if="productCard.reaction.name_d">
        <div
          :class="{
            'product-reaction': true,
            'product-reaction-light': productCard.reaction.name_d
              ? productCard.reaction.name_d
                  .toLowerCase()
                  .includes('indskærpelse')
              : false,
            'product-reaction-medium': productCard.reaction.name_d
              ? productCard.reaction.name_d.toLowerCase().includes('forbud')
              : false,
            'product-reaction-dark': productCard.reaction.name_d
              ? productCard.reaction.name_d.toLowerCase().includes('påbud')
              : false,
          }"
        >
          {{ productCard.reaction.name_d }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["productCard"],
  data() {
    return { productImageUrls: [] };
  },
  mounted() {
    this.updateImageDict();
  },
  watch: {
    productCard() {
      this.productImageUrls = [];
      this.updateImageDict();
    },
  },
  methods: {
    moveToFirstIndex(array, fromIndex) {
      if (fromIndex > 0) {
        [array[0], array[fromIndex]] = [array[fromIndex], array[0]];
      }
    },
    updateImageDict() {
      if (this.productCard.productPictures.length > 0) {
        this.productCard.productPictures.forEach((element) => {
          if (this.productImageDict[element.pictureId]) {
            if (element.productPictureCategory.name === "PRODUKT") {
              this.productImageUrls.unshift(
                this.productImageDict[element.pictureId]
              );
            } else {
              this.productImageUrls.push(
                this.productImageDict[element.pictureId]
              );
            }
          } else {
            this.getProductPicture(
              element.pictureId,
              element.productPictureCategory.name,
              element.source
            );
          }
        });
      }
    },
    getProductPicture(pictureId, pictureCategory, pictureSource) {
      axios
        .get(process.env.VUE_APP_PRODUCTS_API + "picture/" + pictureId, {
          responseType: "blob",
        })
        .then((response) => {
          console.log(
            "Response from " +
              process.env.VUE_APP_PRODUCTS_API +
              "picture/" +
              pictureId,
            response.data
          );
          let productImageUrl = {
            url: URL.createObjectURL(response.data),
            source: pictureSource,
          };
          if (pictureCategory === "PRODUKT") {
            this.productImageUrls.unshift(productImageUrl);
          } else {
            this.productImageUrls.push(productImageUrl);
          }
          this.$store.commit("products/addImageUrl", {
            id: pictureId,
            pictureObject: productImageUrl,
          });
        })
        .catch((error) => {
          console.log(
            "Error from " +
              process.env.VUE_APP_PRODUCTS_API +
              "picture/" +
              pictureId,
            error
          );
        });
    },
  },
  computed: {
    productImageDict: {
      get() {
        return this.$store.state.products.productImageDict;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.card-img-overlay .product-reaction {
  font-size: 12pt;
  padding: 7px 15px;
}
.card.product-card.product-card-no-animation {
  &:hover,
  &:focus {
    transform: none;
    cursor: default !important;
  }
}
</style>
